// extracted by mini-css-extract-plugin
export default {"pageWrap":"hc-z","fullWidth":"ic-z","heading":"jc-z","fullBleed":"kc-z","hidden":"lc-z"};